import { useCallback, useEffect, useState } from "react";

import { postEmailValidation } from "features/verificar-email/services/verifyEmailApi";
import type { EmailCopy } from "features/verificar-email/types";

const LOADING: EmailCopy = {
  title: "Validação de E-mail",
  subTitle: "",
  text: "Carregando...",
};

const SUCCESS: EmailCopy = {
  title: "E-mail validado!",
  subTitle:
    "Agora você pode acessar seu portal e visualizar todas suas unidades em um único login.",
  text: "Seu e-mail foi validado com sucesso!",
};

const EXPIRED: EmailCopy = {
  title: "E-mail expirado!",
  subTitle:
    "O seu e-mail de ativação expirou, para validar novamente basta você reenvia-lo novamente para ativar",
  text: "Não foi possível concluir seu cadastro, seu e-mail de ativação foi expirado, favor tente novamente",
};

export function useVerifyEmail(): {
  emailState: EmailCopy;
  errorState: number | null;
  loading: boolean;
  steppers: string[];
} {
  const [loading, setLoading] = useState(false);
  const [emailState, setEmailState] = useState<EmailCopy>(LOADING);
  const [errorState, setErrorState] = useState<number | null>(null);
  const [steppers, setSteppers] = useState(["Validação E-mail"]);

  const requestValidationEmail = useCallback(
    async (token: string | null, userId: string | null) => {
      setLoading(true);

      try {
        await postEmailValidation(userId, token);
        setEmailState(SUCCESS);
        setSteppers(["E-mail Validado"]);
      } catch {
        setEmailState(EXPIRED);
        setErrorState(1);
        setSteppers(["Token Expirado"]);
      }
      setLoading(false);
    },
    []
  );

  useEffect(() => {
    const { search } = window.location;
    const params = new URLSearchParams(search);
    const token = params.get("token");
    const userId = params.get("user-id");
    requestValidationEmail(token, userId);
  }, [requestValidationEmail]);

  return {
    loading,
    emailState,
    errorState,
    steppers,
  };
}
